import { render, staticRenderFns } from "./RequestItem.vue?vue&type=template&id=2273f220&scoped=true&"
import script from "./RequestItem.vue?vue&type=script&lang=ts&"
export * from "./RequestItem.vue?vue&type=script&lang=ts&"
import style0 from "./RequestItem.vue?vue&type=style&index=0&id=2273f220&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2273f220",
  null
  
)

export default component.exports